// extracted by mini-css-extract-plugin
export var div = "IEBanner-module--div--73eed";
export var p = "IEBanner-module--p--5428a";